import React from "react";
import { ActivityFeedItem, PaginationInfo, User } from "../../api/types.ts";
import { ActivityFeedCard } from "./ActivityFeedCard.tsx";

interface ActivityFeedProps {
  activityFeed: ActivityFeedItem[];
  friends?: Partial<User>[];
  profile?: Partial<User>;
  timeFormat?: "12h" | "24h";
  pagination?: PaginationInfo;
  onPageChange?: (page: number) => void;
}

const ActivityFeed: React.FC<ActivityFeedProps> = ({
  activityFeed,
  friends,
  profile,
  timeFormat,
  pagination,
  onPageChange,
}) => {
  return (
    <div className="flex flex-col gap-6 py-4">
      {!activityFeed || activityFeed.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500 mb-4">There is no activity to show.</p>
        </div>
      ) : (
        <>
          {activityFeed.map((item) => (
            <ActivityFeedCard
              key={item.id}
              activityFeedItem={item}
              profile={profile}
              friend={
                friends?.find((friend) => friend.id === item.user_id) ??
                (item.user_id === profile?.id ? profile : undefined)
              }
              timeFormat={timeFormat}
            />
          ))}
          {pagination && onPageChange && pagination.total_pages > 1 && (
            <div className="flex items-center justify-center gap-2 pt-4 pb-2">
              <button
                onClick={() => onPageChange(pagination.page - 1)}
                disabled={!pagination.has_prev}
                className="px-3 py-1.5 rounded border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium"
              >
                Previous
              </button>
              <span className="text-sm text-gray-600 px-2">
                Page {pagination.page} of {pagination.total_pages}
              </span>
              <button
                onClick={() => onPageChange(pagination.page + 1)}
                disabled={!pagination.has_next}
                className="px-3 py-1.5 rounded border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium"
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export { ActivityFeed };
